export const COMPETENCIES_CONSTANTS = {
  exceptionalLeaderCode: 'ELB',
  exceedsExpectationsCode: 'EEL',
  greatestStrengthCode: 'GS',
  opportunityForImprovementCode: 'OI',
};

const valuesKeys = [
  'decisionAuthority',
  'listenToIdeas',
  'trainingOpportunities',
  'learning',
  'communication',
  'communityInvolvement',
  'ethics',
  'expectations',
  'inclusionDiversity',
  'manager',
  'performanceFeedback',
  'mission',
  'recognition',
  'technology',
  'safety',
  'seniorLeadershipVisibility',
  'coworkers',
  'workLifeBalance',
];

const isSelectStaffingInfo = (result) => {
  return result.leadership_model_processings[0]?.percentiles.onsitePerformance !== undefined;
};

export const processPersonalityResult = (result) => {
  const personality = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['H'];

  if (assessment) {
    const codes = assessment.questions;
    personality.assessmentId = assessment.assessment.id;
    personality.codes = codes;
    personality.scores = {};

    if (!isSelectStaffingInfo(result)) {
      // Honest-Humility [=((H_HF6+H_HS3+H_HS1+H_HF2)/4)]
      personality.scores.honestyHumility = {};
      personality.scores.honestyHumility.fairness = (codes['HF6'] + codes['HF2']) / 2;
      personality.scores.honestyHumility.sincerity = (codes['HS1'] + codes['HS3']) / 2;
      personality.scores.honestyHumility.overall = (codes['HF6'] + codes['HS3'] + codes['HS1'] + codes['HF2']) / 4;

      // Emotional Control [=((H_Ei6+H_Ei5+H_EC4+H_EC9+H_EmCo5+H_EmCo7)/6)]
      personality.scores.emotionalControl = {};
      personality.scores.emotionalControl.collectedness = (codes['EmCo7'] + codes['EmCo5']) / 2;
      personality.scores.emotionalControl.courageous = (codes['Ec4'] + codes['Ec9']) / 2;
      personality.scores.emotionalControl.independence = (codes['Ei6'] + codes['Ei5']) / 2;
      personality.scores.emotionalControl.overall =
        (codes['Ei6'] + codes['Ei5'] + codes['Ec4'] + codes['Ec9'] + codes['EmCo5'] + codes['EmCo7']) / 6;

      // Extraversion [=((H_ExL1+H_ExL4+H_ExS2+H_ExSB1+H_ExSB2+H_ExSSE1+H_ExSSE4)/7)]
      personality.scores.extraversion = {};
      personality.scores.extraversion.liveliness = (codes['ExL1'] + codes['ExL4']) / 2;
      personality.scores.extraversion.socialbility = codes['ExS2'];
      personality.scores.extraversion.socialBoldness = (codes['ExSB1'] + codes['ExSB2']) / 2;
      personality.scores.extraversion.socialSelfEsteem = (codes['ExSSE1'] + codes['ExSSE4']) / 2;
      personality.scores.extraversion.overall =
        (codes['ExL1'] +
          codes['ExL4'] +
          codes['ExS2'] +
          codes['ExSB1'] +
          codes['ExSB2'] +
          codes['ExSSE1'] +
          codes['ExSSE4']) /
        7;

      // Conscientiousness [=((H_CD7+H_CD8+H_CO2+H_CO4+H_CP3+H_CP5+H_Cpru_new1+H_CPru6)/8)]
      personality.scores.conscientiousness = {};
      personality.scores.conscientiousness.diligence = (codes['CD7'] + codes['CD8']) / 2;
      personality.scores.conscientiousness.organization = (codes['CO2'] + codes['CO4']) / 2;
      personality.scores.conscientiousness.perfectionism = (codes['CP3'] + codes['CP5']) / 2;
      personality.scores.conscientiousness.prudence = (codes['CPru6'] + codes['Cpru_New1']) / 2;
      personality.scores.conscientiousness.overall =
        (codes['CD7'] +
          codes['CD8'] +
          codes['CO2'] +
          codes['CO4'] +
          codes['CP3'] +
          codes['CP5'] +
          codes['Cpru_New1'] +
          codes['CPru6']) /
        8;
    } else {
      // Use arrays directly define by Craig's spreadsheet. John them ina separate step.

      // Personality
      const Consc_Office_Perf_QuestionCodes = [
        'CD3',
        'CD7',
        'CD8',
        'CO2',
        'CO4',
        'CP1',
        'CP3',
        'CP5',
        'CPru1',
        'CPru3',
        'Cpru_new1',
        'Cpru_new2',
      ];
      const Remote_H_C_Perf_R_QuestionCodes = ['CD3', 'CD7', 'CD8', 'CO2', 'CO4', 'CP3', 'CP5', 'Cpru_new1'];

      const conscientiousnessKeys = [...Consc_Office_Perf_QuestionCodes];

      let newCodes = Remote_H_C_Perf_R_QuestionCodes.filter((code) => {
        !conscientiousnessKeys.includes(code);
      }).map((code) => {
        return code;
      });
      conscientiousnessKeys.push(...newCodes);

      let conscientiousnessSum = 0;
      conscientiousnessKeys.forEach((key) => {
        conscientiousnessSum += codes[key];
      });
      personality.scores.conscientiousness = {};
      personality.scores.conscientiousness.overall = conscientiousnessSum / conscientiousnessKeys.length;

      // Emotional Control
      const Remote_H_E_Perf_QuestionCodes = ['Ec4', 'Ec8', 'Ec9', 'EmCo5', 'EmCo4', 'EmCo7'];
      let emotionalControlSum = 0;
      Remote_H_E_Perf_QuestionCodes.forEach((key) => {
        emotionalControlSum += codes[key];
      });
      personality.scores.emotionalControl = {};
      personality.scores.emotionalControl.overall = emotionalControlSum / Remote_H_E_Perf_QuestionCodes.length;

      // Agreeableness
      const H_A_Loyal_R_QuestionCodes = ['AF1', 'AF3', 'AF4', 'AFx2', 'AFx3', 'AG2', 'AG3', 'AP2', 'AP3'];
      const Remote_H_A_Loyal_QuestionCodes = ['AF3', 'AFx3', 'AFx4', 'AG3', 'AG4'];
      const agreeablenessKeys = [...H_A_Loyal_R_QuestionCodes];
      newCodes = Remote_H_A_Loyal_QuestionCodes.filter((code) => {
        !agreeablenessKeys.includes(code);
      }).map((code) => {
        return code;
      });
      agreeablenessKeys.push(...newCodes);

      let agreeablenessSum = 0;
      agreeablenessKeys.forEach((key) => {
        agreeablenessSum += codes[key];
      });
      personality.scores.agreeableness = {};
      personality.scores.agreeableness.overall = agreeablenessSum / agreeablenessKeys.length;

      // Honesty Humility
      const H_H_Loyal_R_QuestionCodes = ['HF2', 'HF3', 'HF6', 'HGA1', 'HGA4', 'HGA_new4', 'HS1', 'HS3'];
      const Remote_H_H_Loyal_QuestionCodes = ['HF3', 'HF6', 'HGA_new4', 'HM2', 'HM3', 'HS1'];
      const honestyHumilityKeys = [...H_H_Loyal_R_QuestionCodes];
      newCodes = Remote_H_H_Loyal_QuestionCodes.filter((code) => {
        !honestyHumilityKeys.includes(code);
      }).map((code) => {
        return code;
      });
      honestyHumilityKeys.push(...newCodes);

      let honestyHumilitySum = 0;
      honestyHumilityKeys.forEach((key) => {
        honestyHumilitySum += codes[key];
      });
      personality.scores.honestyHumility = {};
      personality.scores.honestyHumility.overall = honestyHumilitySum / honestyHumilityKeys.length;
    }

    return personality;
  }

  return null;
};

export const processSituationalJudgmentResult = (result) => {
  const situationJudgment = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['SJ'];

  if (assessment) {
    const codes = assessment.questions;
    situationJudgment.assessmentId = assessment.assessment.id;
    situationJudgment.codes = codes;
    situationJudgment.scores = {};
    situationJudgment.variableKeys = [];

    if (!isNaN(codes['BCT'])) {
      situationJudgment.variableKeys.push('BCT');
      situationJudgment.scores['BCT'] = +codes['BCT'] + 1;
      situationJudgment.scores.buildingCohesiveTeams = situationJudgment.scores['BCT'];
    }
    if (!isNaN(codes['EFR'])) {
      situationJudgment.variableKeys.push('EFR');
      situationJudgment.scores['EFR'] = +codes['EFR'] + 1;
      situationJudgment.scores.executingForResults = situationJudgment.scores['EFR'];
    }
    if (!isNaN(codes['BRT'])) {
      situationJudgment.variableKeys.push('BRT');
      situationJudgment.scores['BRT'] = +codes['BRT'] + 1;
      situationJudgment.scores.buildingResilientTeams = situationJudgment.scores['BRT'];
    }
  }

  return situationJudgment;
};

export const processExperienceResult = (result) => {
  const experience = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['BD'];

  if (assessment) {
    const codes = assessment.questions;
    experience.assessmentId = assessment.assessment.id;
    experience.codes = codes;
    experience.scores = {};

    if (!isSelectStaffingInfo(result)) {
      experience.scores.riskTaking = codes['Rule'];
      experience.scores.conflictResolution = codes['Con1'];
      experience.scores.dealingWithConflict = codes['Con2'];
      experience.scores.meetingFacilitation = codes['LM1'];
      experience.scores.directCommunication = codes['UMComm'];
    } else {
      const variableKeys = [];

      for (const key in codes) {
        let value = codes[key];
        if (!isNaN(value)) {
          value = +value;
        }
        experience.scores[key] = value;
        variableKeys.push(key);
      }

      experience.variableKeys = variableKeys;
    }
  }

  return experience;
};

export const processValuesResult = (result, orgValues) => {
  const values = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['V'];

  if (assessment) {
    const codes = assessment.questions;
    values.assessmentId = assessment.assessment.id;
    values.codes = codes;
    values.scores = {};
    values.ratings = {};
    values.priorities = {};
    values.titles = {};

    if (!isSelectStaffingInfo(result)) {
      values.scores.decisionAuthority = orgValues['decisionAuthority'] - codes['DecAut'];
      values.priorities.decisionAuthority = 1;
      values.titles.decisionAuthority = 'Authority to Make Decisions';

      values.scores.listenToIdeas = orgValues['listenToIdeas'] - codes['List'];
      values.priorities.listenToIdeas = 1;
      values.titles.listenToIdeas = 'Ideas are Heard';

      values.scores.trainingOpportunities = orgValues['trainingOpportunities'] - codes['Train'];
      values.priorities.trainingOpportunities = 2;
      values.titles.trainingOpportunities = 'Availability of Training Opportunities';

      values.scores.learning = orgValues['learning'] - codes['Learn'];
      values.priorities.learning = 3;
      values.titles.learning = 'Opportunity to Learn New Things';

      values.scores.communication = orgValues['communication'] - codes['Comm'];
      values.priorities.communication = 1;
      values.titles.communication = 'Transparent Communication';

      values.scores.communityInvolvement = orgValues['communityInvolvement'] - codes['C_Inv'];
      values.priorities.communityInvolvement = 3;
      values.titles.communityInvolvement = 'Community Involvement';

      values.scores.ethics = orgValues['ethics'] - codes['Ethic'];
      values.priorities.ethics = 2;
      values.titles.ethics = 'High Ethical Standards';

      values.scores.expectations = orgValues['expectations'] - codes['Expect'];
      values.priorities.expectations = 2;
      values.titles.expectations = 'Clear Expectations and Understanding of Role';

      values.scores.inclusionDiversity = orgValues['inclusionDiversity'] - codes['Inclus'];
      values.priorities.inclusionDiversity = 1;
      values.titles.inclusionDiversity = 'Climate of Inclusion';

      values.scores.manager = orgValues['manager'] - codes['Mgr'];
      values.priorities.manager = 2;
      values.titles.manager = 'Manager Effectiveness';

      values.scores.performanceFeedback = orgValues['performanceFeedback'] - codes['Perf'];
      values.priorities.performanceFeedback = 1;
      values.titles.performanceFeedback = 'Feedback & Coaching';

      values.scores.mission = orgValues['mission'] - codes['Miss'];
      values.priorities.mission = 1;
      values.titles.mission = "Organization's Mission & Values";

      values.scores.recognition = orgValues['recognition'] - codes['Recog'];
      values.priorities.recognition = 2;
      values.titles.recognition = 'Reward & Recognition';

      values.scores.technology = orgValues['technology'] - codes['Tech'];
      values.priorities.technology = 3;
      values.titles.technology = 'State-of-the-Art Technology/Resources';

      values.scores.safety = orgValues['safety'] - codes['Safe'];
      values.priorities.safety = 2;
      values.titles.safety = 'Safety';

      values.scores.seniorLeadershipVisibility = orgValues['seniorLeadershipVisibility'] - codes['SLV'];
      values.priorities.seniorLeadershipVisibility = 3;
      values.titles.seniorLeadershipVisibility = 'Visibility with Senior Leadership';

      values.scores.coworkers = orgValues['coworkers'] - codes['Cowork'];
      values.priorities.coworkers = 1;
      values.titles.coworkers = 'Relationship with Co-workers';

      values.scores.workLifeBalance = orgValues['workLifeBalance'] - codes['WLB'];
      values.priorities.workLifeBalance = 2;
      values.titles.workLifeBalance = 'Work-life Balance';

      const valuesScores = [];
      valuesKeys.forEach((key) => {
        const score = values.scores[key];
        let rating = 2;
        if (score < -1.25) {
          rating = 1;
        } else if (score > -0.5) {
          rating = 3;
        }

        values.ratings[key] = rating;
        valuesScores.push({
          key,
          score,
          rating,
          priority: values.priorities[key],
        });
      });

      valuesScores.sort((a, b) => {
        if (a.score !== b.score) {
          if (a.score > b.score) {
            return -1;
          } else if (a.score < b.score) {
            return 1;
          }
        } else {
          if (a.priority < b.priority) {
            return -1;
          } else if (a.priority > b.priority) {
            return 1;
          }
        }

        return 0;
      });

      const misAligned = [];
      const aligned = [];
      valuesScores.forEach((item) => {
        if (item.rating === 3) {
          aligned.push(item.key);
        } else {
          misAligned.push(item.key);
        }
      });

      values.misAligned = misAligned.reverse();
      values.aligned = aligned;
      values.valuesScores = valuesScores;
    } else {
      const variableKeys = [];

      for (const key in codes) {
        let value = codes[key];
        if (!isNaN(value)) {
          value = +value;
        }
        values.scores[key] = value;
        variableKeys.push(key);
      }

      values.variableKeys = variableKeys;
    }
  }

  return values;
};

const setCommonCompetenciesScores = (competencies) => {
  competencies.scores.exceptionalLeader = competencies.scores[COMPETENCIES_CONSTANTS.exceptionalLeaderCode];
  competencies.scores.exceedsExpectations = competencies.scores[COMPETENCIES_CONSTANTS.exceedsExpectationsCode];
  competencies.scores.greatestStrength = competencies.scores[COMPETENCIES_CONSTANTS.greatestStrengthCode];
  competencies.scores.opportunityForImprovement =
    competencies.scores[COMPETENCIES_CONSTANTS.opportunityForImprovementCode];
};

const shuffleCompetenciesComments = (userId, unshuffled) => {
  const factor = userId;
  const remainder = factor % unshuffled.length;
  return unshuffled
    .map((value, index) => {
      const sort = index >= remainder ? index - remainder : index + unshuffled.length;
      return {
        value,
        sort,
      };
    })
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
};

export const processSelfCompetenciesResult = (result, raterCompetencies) => {
  const competencies = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['C'];

  if (assessment) {
    const codes = assessment.questions;
    competencies.assessmentId = assessment.assessment.id;
    competencies.codes = codes;
    competencies.scores = {};

    const variableKeys = [];

    const keys = Object.keys(codes);
    const variableCodes = keys.slice(0, keys.length - 4);

    for (const property in codes) {
      let value = codes[property];
      if (!isNaN(value)) {
        value = +value;
      }
      const pos = property.indexOf('_');
      const competenciesKey = property.substring(0, pos);
      competencies.scores[competenciesKey] = value;

      if (variableCodes.includes(property)) {
        variableKeys.push(competenciesKey);
      }
    }

    competencies.variableKeys = variableKeys;

    setCommonCompetenciesScores(competencies);

    if (raterCompetencies.scores) {
      competencies.scores.overallLeadership =
        (raterCompetencies.scores.exceptionalLeader + raterCompetencies.scores.exceedsExpectations) / 2;

      competencies.scores.greatestStrengthCollection = [];
      competencies.scores.opportunityForImprovementCollection = [];

      if (raterCompetencies.scores.greatestStrength) {
        raterCompetencies.scores.greatestStrength.split(/\r?\n/).forEach((comment) => {
          if (comment.length > 0) {
            competencies.scores.greatestStrengthCollection.push(comment);
          }
        });
      }
      if (competencies.scores.greatestStrengthCollection.length > 0) {
        competencies.scores.greatestStrengthCollection = shuffleCompetenciesComments(
          result.user_id,
          competencies.scores.greatestStrengthCollection
        );
      }

      if (raterCompetencies.scores.opportunityForImprovement) {
        raterCompetencies.scores.opportunityForImprovement.split(/\r?\n/).forEach((comment) => {
          if (comment.length > 0) {
            competencies.scores.opportunityForImprovementCollection.push(comment);
          }
        });
      }
      if (competencies.scores.opportunityForImprovementCollection.length > 0) {
        competencies.scores.opportunityForImprovementCollection = shuffleCompetenciesComments(
          result.user_id,
          competencies.scores.opportunityForImprovementCollection
        );
      }

      const strengthsScores = [];
      variableKeys.forEach((key) => {
        strengthsScores.push({
          key,
          score: raterCompetencies.scores[key] - competencies.scores[key],
        });
      });

      strengthsScores.sort((a, b) => {
        if (a.score > b.score) {
          return -1;
        } else if (a.score < b.score) {
          return 1;
        }

        return 0;
      });

      const blindSpots = [];
      strengthsScores.slice(-3).forEach((strength) => {
        if (strength.score <= -1) {
          blindSpots.push(strength);
        }
      });
      const hiddenStrengths = [];
      strengthsScores.slice(0, 3).forEach((strength) => {
        if (strength.score >= 1) {
          hiddenStrengths.push(strength);
        }
      });
      competencies.blindSpots = blindSpots.reverse();
      competencies.hiddenStrengths = hiddenStrengths;
    }
  }

  return competencies;
};

export const generateInterviewCompetenciesResult = (dimensionScores) => {
  const competencies = {};
  competencies.scores = {};

  const dimensionKeys = [];

  let overall = 0;
  const keys = Object.keys(dimensionScores);
  for (const dimension of keys) {
    if (dimension !== 'INTERVIEW_CMTS') {
      let value = dimensionScores[dimension];
      if (!isNaN(value)) {
        value = +value;
      }
      competencies.scores[dimension] = value;
      overall += value;
      dimensionKeys.push(dimension);
    }
  }

  competencies.variableKeys = dimensionKeys;
  competencies.scores.overall = overall;
  competencies.comments = dimensionScores['INTERVIEW_CMTS'];
  return competencies;
};

export const processRaterCompetenciesResult = (result) => {
  const competencies = {};
  const assessment = result.leadership_model_processings[0]?.questions_by_assessment['CO'];

  if (assessment) {
    const codes = assessment.questions;
    competencies.assessmentId = assessment.assessment.id;
    competencies.codes = codes;
    competencies.scores = {};

    for (const property in codes) {
      let value = codes[property];
      if (!isNaN(value)) {
        value = +value;
      }

      const pos = property.indexOf('_');
      const competenciesKey = property.substring(0, pos);
      competencies.scores[competenciesKey] = value;
    }

    setCommonCompetenciesScores(competencies);
  }

  return competencies;
};
